import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { SystemParamRule } from "@interfaces/systemParamRule.interface";
import { SystemParameterService } from "@services/systemParameter.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "system-param-id",
	styleUrls: ["system-param-id.css"],
	templateUrl: "system-param-id.html"
})
export class SystemParamIdAdminComponent {
	deleteEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "System Param Value"
	itemUrl = `${location.href.split("/")[3]}/${location.href.split("/")[4]}/${location.href.split("/")[5]}/values`;
	systemParamValues: SystemParamRule[] = [];
	title: string;
	
	constructor(private route: ActivatedRoute, private toastService: ToastService, private router: Router, private itemService: SystemParameterService) {
		this.title = `${this.itemType}s`;
		this.deleteRow = this.deleteRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.route.params
			.subscribe((params) => this.getItemsById(params.id));
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if(result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.route.params
							.subscribe((params) => this.getItemsById(params.id));
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getItemsById(id: number) {
		this.itemService.getSystemParamValuesById(id)
			.subscribe(
				(res: any) => this.systemParamValues = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}